module.exports = __webpack_public_path__ + "img/marker_store.06b22934.svg";